export const errorMessages = {
  characters: '8 characters',
  capital: '1 capital letter',
  number: '1 number',
  lowercase: '1 lowercase letter',
  specialCharacter: '1 special character',
};

interface IValidation {
  password: string,
  repeatPassword: string,
  code: string
}

type IValidationReturn = {[key:string]:string};

export const resetPasswordValidation = ({ password = '', repeatPassword = '', code } : IValidation) :IValidationReturn => {
  const errors: {[key:string]:string} = {};

  if (password?.length < 8) {
    errors.characters = errorMessages.characters;
  }

  if (!password.match(/\d/gm)) {
    errors.number = errorMessages.number;
  }

  if (!password.match(/(?=.*[a-z])/)) {
    errors.lowercase = errorMessages.lowercase;
  }

  if (!password.match(/(?=.*[A-Z])/)) {
    errors.capital = errorMessages.capital;
  }

  if (!password.match(/(?=.*["@#$!%*?&(){}~+,-./:;<\][=>?])/)) {
    errors.specialCharacter = errorMessages.specialCharacter;
  }

  if (password !== repeatPassword) {
    errors.repeatPassword = 'Please make sure your passwords match';
  }

  if (!code) {
    errors.code = 'Code field should not be empty';
  }

  return errors;
};
